<template>
  <article class="p-d-flex p-mb-3">
    <div class="flex-grow-1">
      <strong>{{speaker.delegate.name}}</strong>
    </div>
    <div>
      <div class="p-d-flex p-ai-center">
        <span v-if="speaker.isActive()">
          <span class="blob green"/>
        </span>
        <speaker-state-display :state="speaker.status"/>
      </div>
    </div>
  </article>
</template>

<script>
import SpeakerStateDisplay from './SpeakerStateDisplay.vue'
export default {
  name: 'SpeakersListItem',
  components: {
    SpeakerStateDisplay
  },
  props: {
    speaker: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/speakers/SpeakersListItem.vue